import { find, register } from '../../../../Javascript/Sysmex/Utils'
import Cookies from 'js-cookie'

const cookiebody = document.body
const CookieConsent = el => {
  const acceptButton = find('[data-accept]', el)

  if (Cookies.get('consent')) {
    refresh()
  } else {
    el.classList.add('sysmexMoleculeCookieConsent_active')
    acceptButton.addEventListener('click', accept.bind(this, el))
    cookiebody.classList.add('body_cookie-active')
  }
}

const accept = el => {
  Cookies.set('consent', 'true', { expires: 90 })
  el.classList.remove('sysmexMoleculeCookieConsent_active')
  cookiebody.classList.remove('body_cookie-active')
}

const refresh = () => {
  Cookies.set('consent', 'true', { expires: 90 })
}

register('CookieConsent', CookieConsent)
